import {CHeliNetwork} from '../networklib/CHeliNetwork';
import {connect, joinVoiceChannel} from '../networklib/networkMediator';
import {GetIHeliNetwork} from '../singleton_registry';

import {getSkyRoomId, getSkywayName, getWorldId} from './dataOps';
import {getSkywayLocalTextDOMElement} from './domOps';
import {hel_chatbadge_ui_update} from './gui_caller';
import {getMainCanvasDOMElement} from './mainCanvasDOM';
import {hel_remove_emoji} from './misc';
import {requestSendingReceivedPacketsFromSkyway} from './moduleCaller';
import {hel_gtag, hel_post_TextField_UserName, hel_set_cookie} from './shared';

import type {Return} from '../errorCodes/models/return';

/**
 * @param peerId
 */
export const hel_skyway_release_player = (peerId: string) => {
  GetIHeliNetwork()?.releasePlayer(peerId);
};

/**
 * @param volume
 */
export const hel_skyway_SetMixerVolume = (volume: number) => {
  GetIHeliNetwork()?.setGlobalPlayerVoiceVolume(volume);
};

/**
 * @param cmd
 * @param id
 * @param param
 */
export const hel_skyway_receive_data = (cmd: string, id: string, param: string) => {
  // RTCコマンド処理
  // console.debug("receive_data / " + data);
  requestSendingReceivedPacketsFromSkyway(cmd, id, param);
};

/**
 * @param id
 * @param text
 */
export const hel_skyway_add_text_chat = (id: string, text: string) => {
  hel_skyway_receive_data('data', id, 'msg:' + text);

  // チャットログスクロール対応
  if (typeof globalThis.hel_if_displayChatMessage === 'function') {
    globalThis.hel_if_displayChatMessage(id, text);
  }

  hel_chatbadge_ui_update(); // チャットログバッジのUI更新
};

/**
 * @deprecated
 * 第1引数 `configKey` は {@link CHeliOldSkywayUnifiedPositionVoiceChannelProvider} 特有である。
 *
 * また、{@link CHeliOldSkywayUnifiedPositionVoiceChannelProvider} 特有のメソッドである {@link CHeliNetwork.connectRoomAfterPeerOpen} を呼び出している。
 * @remarks
 * TODO: agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 */
export const hel_skyway_main = async (configKey?: string, AutoConnect: boolean = false) => {
  await connect(configKey);

  // Peer接続完了後に自動的にルームにジョインする
  if (AutoConnect) {
    // RTC抽象化前の実装。互換性を保つために残している
    // 抽象化後はhel_net_join_pos_channel・hel_net_leave_pos_channel・hel_net_join_voice_channel・hel_net_leave_voice_channelを使用する
    GetIHeliNetwork()?.connectRoomAfterPeerOpen();
  }
};

/**
 * @remarks
 * TODO: agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @param param
 */
export const hel_skyway_send_data = (param: string) => {
  GetIHeliNetwork()?.sendData(param);
};

/**
 * @remarks
 * TODO: agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 */
export const hel_skyway_join = () => {
  joinVoiceChannel(getSkyRoomId());
};

/**
 * @remarks
 * TODO: agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 */
export const hel_skyway_send_myinfo = () => {
  GetIHeliNetwork()?.sendMyPlayerInfoToAllPlayer();
};

/**
 * @remarks
 * TODO: agora/skyway/photon/chalcedonyで今後realtimeEngineSDKに分岐
 * @param focus
 */
export const hel_skyway_send_chat_text = (focus = true) => {
  const skywayLocalText = getSkywayLocalTextDOMElement();
  if (!skywayLocalText || skywayLocalText.value === '') {
    return;
  }
  const value = skywayLocalText.value;
  hel_remove_emoji(skywayLocalText);

  // Send message to all of the peers in the room via websocket
  const replace_text = hel_skyway_to_code_colon(value);
  hel_skyway_send_data('msg:' + replace_text);

  // peerIdの取得
  hel_skyway_add_text_chat(GetIHeliNetwork()?.getPlayerId() ?? '', replace_text);
  skywayLocalText.value = '';

  const mainCanvas = getMainCanvasDOMElement();
  if (focus && mainCanvas !== undefined) {
    mainCanvas.focus();
  }

  hel_gtag('SendTextChat', {param0: getWorldId()});
};

export type AuthorizationJwtDataListResult = Return<{jwts: AuthorizationJwtData[]}>;

export type AuthorizationJwtData = {
  spatium_code: string;
  world_code: string;
  jwt: string;
} & (
  | {
      scope: 'world';
    }
  | {
      scope: 'position_channel';
      position_channel_id: string;
    }
);

export const hel_net_select_authorization_jwt = (args: {
  jwtDataList: AuthorizationJwtData[];
  spatiumCode: string;
  worldCode: string;
  positionChannelId?: string;
}): string | null => {
  if (args.positionChannelId !== null) {
    const jwtData = args.jwtDataList.find(
      (jwtData) =>
        jwtData.scope === 'position_channel' &&
        jwtData.position_channel_id === args.positionChannelId
    );
    if (jwtData) {
      return jwtData.jwt;
    }
  }

  return (
    args.jwtDataList.find(
      (jwtData) => jwtData.scope === 'world' && jwtData.world_code === args.worldCode
    )?.jwt ?? null
  );
};

/**
 * Replace ":" to "&colon\;"
 * @param text
 */
export const hel_skyway_to_code_colon = (text: string): string => {
  return text.replace(':', '&colon;');
};

export const hel_skyway_set_user_name = (name: string) => {
  const currentname = getSkywayName();
  if (currentname === name) return;

  hel_set_cookie('playername', name);
  hel_post_TextField_UserName(true);
};
